<template>
    <div id="app">
        <!-- Navigation -->
        <navigation v-if="isAuthorized"></navigation>
        <!-- End Navigation -->

        <!-- Router View -->
        <router-view :key="$route.fullPath"></router-view>
        <!-- End Router View -->

        <!-- Prefooter -->
        <footer v-if="isAuthorized">
            <div class="container">
                Copyright 2019 Brandweer Westhoek
                <br />
                <template v-for="(page, index) in footerPages">
                    <span :key="page.slug">
                        <router-link
                            :to="{ name: 'page', params: { slug: page.slug }}"
                        >{{ page.title }}</router-link>

                        <span v-if="index + 1 < footerPages.length" class="mr-2 ml-2">-</span>
                    </span>
                </template>
            </div>
        </footer>
        <!-- End Prefooter -->

        <!-- Cookie Notice -->
        <cookie-notice></cookie-notice>
        <!-- End Cookie Notice -->
    </div>
</template>

<style lang="scss">
@import "~bootstrap/scss/bootstrap.scss";
@import "~font-awesome/css/font-awesome.css";
@import "~noty/src/noty.scss";
@import "~noty/src/themes/mint.scss";
@import "styles/main.scss";
</style>

<script>
export default {
    computed: {
        isAuthorized() {
            return this.$store.getters.isAuthorized;
        },

        footerPages() {
            return this.$store.getters.footerPages;
        }
    },
    data() {
        return {
            showCart: false
        };
    },
    watch: {
        isAuthorized() {
            this.getCategories();
            this.getPages();
            this.getMe();
        }
    },
    mounted() {
        if (this.isAuthorized) {
            this.getCategories();
            this.getPages();
            this.getMe();
        }

        this.$root.$on("notify", payload => {
            new Noty({
                type: payload.type,
                text: payload.text,
                layout: "bottomRight",
                timeout: 3000
            }).show();
        });

        this.$root.$on("cart-changed", payload => {
            this.getMe();
        });
    },
    methods: {
        getCategories() {
            this.$http
                .get("/categories")
                .then(res => {
                    this.$store.commit("storeCategories", res.data.data);
                })
                .catch(err => {
                    console.log(err);
                });
        },

        getPages() {
            this.$http
                .get("/pages")
                .then(res => {
                    this.$store.commit("storePages", res.data.data);
                })
                .catch(err => console.log(err));
        },

        getMe() {
            this.$http
                .post("/auth/me")
                .then(res => {
                    this.$store.commit("setUser", res.data.data);
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
};
</script>

